import { render, staticRenderFns } from "./bulk-change-data.vue?vue&type=template&id=65a17ad1"
import script from "./bulk-change-data.vue?vue&type=script&lang=js"
export * from "./bulk-change-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports